import axios from 'axios'
import store from '../../store/index'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

/* const i18n = new VueI18n({
  locale: store.state.loading.language, // set locale
  fallbackLocale: 'hu',
  silentTranslationWarn: true,
  messages: {
    en: store.state.loading.languages.en,
    hu: store.state.loading.languages.hu
  } // set locale messages
}) */

axios.interceptors.request.use(
  function (request) {
    if (request.headers.disableLoading && request.headers.disableLoading === true) {
      store.commit('loading/change', false)
    } else {
      store.commit('loading/change', true)
    }
    return request
  }
)

axios.interceptors.response.use(
  function (response) {
    store.commit('loading/change', false)
    /* if (response.config.method !== 'get' && response.data !== '0' && response.data !== 0) {
      store.commit('loading/changeUnsaved', false)
      window.jQuery.notify({
        // options
        message: i18n.t('Művelet sikeresen végrehajtva!'),
        icon: 'fa fa-check',
        title: i18n.t('Sikeres!')
      }, {
        // settings
        type: 'success',
        placement: {
          from: 'bottom',
          align: 'right'
        },
        allow_dismiss: true,
        newest_on_top: true
      })
    } */
    return response
  },
  function (error) {
    store.commit('loading/change', false)
    /* if (error.response) {
      let message = error.response.data.message
      if (error.response.data.message === 'undefined') {
        message = ''
      }
      window.jQuery.notify({
        // options
        message: message,
        icon: 'fa fa-warning',
        title: i18n.t('Hiba történt!')
      }, {
        // settings
        type: 'danger',
        placement: {
          from: 'bottom',
          align: 'right'
        },
        allow_dismiss: true,
        newest_on_top: true
      })
    } else {
      window.jQuery.notify({
        // options
        message: i18n.t('Hiba történt a művelet során.'),
        icon: 'fa fa-warning',
        title: i18n.t('Hiba történt!')
      }, {
        // settings
        type: 'danger',
        placement: {
          from: 'bottom',
          align: 'right'
        },
        allow_dismiss: true,
        newest_on_top: true
      })
  } */

    return error
  }
)



// WEBPACK FOOTER //
// ./src/assets/services/axios-interceptor.js